module.exports = __webpack_public_path__ + "img/title-@2x.8781d9cd.png";